module.exports = "../images/dock@2x.jpg?v=ad1412b";